"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const StyledColumn = _styledComponents.default.div`
  box-sizing: border-box;
  float: left;
  min-height: 1px;
  width: 100%;
  ${({
  columnAlign
}) => (columnAlign === "center" || columnAlign === "middle") && "text-align: center"}

  ${({
  columnAlign
}) => columnAlign === "right" && "text-align: right"}
  ${({
  columns
}) => (0, _styledComponents.css)`
    width: ${100 / columns}%;
  `}
  ${({
  columns,
  columnSpan
}) => (0, _styledComponents.css)`
    width: ${100 / columns * +columnSpan}%;
  `}
  ${({
  columns,
  columnOffset
}) => (0, _styledComponents.css)`
    margin-left: ${100 / columns * +columnOffset}%;
  `}
`;
var _default = StyledColumn;
exports.default = _default;